import React from 'react';

import Footer from '../components/footer';
import Header from '../components/header';
import Banner from '../components/section/bannerSection';
import Services from '../components/section/servicesSection';
import About from '../components/section/aboutSection';
import ProductSection from '../components/section/productSection';
import NewsEventsSection from '../components/section/newseventSection';
import ServicesSection from '../components/section/servicesSection';
import GallerySection from '../components/section/gallerySection';
import ClientsSection from '../components/section/clientSection';
function Home() {
    return (
        <>
            <Header />
            <Banner />
            <Services />
            <About />
            <ProductSection />
            <NewsEventsSection />
            <ServicesSection />
            <GallerySection />
            <ClientsSection />
            <Footer />
        </>
    );
}

export default Home;
